var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-param-reassign */
/* eslint-disable @mizdra/layout-shift/require-size-attributes */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { getImageURL } from '../utils/GeneralUtil';
var DefaultPerkIcon = getImageURL('ProTiers/cardIcon-ProXtraPerks-square.svg');
// Util to replace just the onerror attribute
export var fallbackImage = function (image, fallbackSrc) {
    if (fallbackSrc === void 0) { fallbackSrc = DefaultPerkIcon; }
    image.target.onerror = null;
    image.target.src = fallbackSrc;
};
// Util to replace the entire img element
export var ImageWithFallback = function (_a) {
    var fallback = _a.fallback, src = _a.src, props = __rest(_a, ["fallback", "src"]);
    var _b = useState(src), imgSrc = _b[0], setImgSrc = _b[1];
    var onError = function () { return setImgSrc(fallback); };
    return React.createElement("img", __assign({ src: imgSrc || fallback, onError: onError }, props));
};
